var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 105,
    viewBox: "0 0 96 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9083 63.3624L88.3948 48.8758C88.3948 38.9422 85.9114 29.4224 81.3585 21.1444L47.6255 52.394V104.339H54.041C76.5986 104.339 95.0172 86.127 95.0172 63.3624H73.9083Z",
    fill: "#2029DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7567 41.2187L7.27013 55.7053C7.27013 65.6389 9.75354 75.1586 14.3065 83.4367L48.0395 52.1871V0.242432H41.624C19.0663 0.242432 0.647705 18.4541 0.647705 41.2187H21.7567Z",
    fill: "#2029DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.53a881cca4c7d09b0e7b20237f7a2268.svg";
export { ForwardRef as ReactComponent };